<template>
<div class="content2">
  <div>
  </div>

  <div class="table-wrap">
    <el-table
      v-loading="loading"
      v-if="pageData" :data="pageData.list"
      border
      style="width: 100%" height="70vh">
      <el-table-column
        align="center"
        prop="zq_region_name"
        label="战区"
        width="120" fixed>
      </el-table-column>
      <el-table-column
        align="center"
        prop="pq_region_name"
        label="片区"
        width="120" fixed>
      </el-table-column>
      <el-table-column
        align="center"
        prop="project_name"
        label="项目名称"
        width="200" fixed>
      </el-table-column>
      <el-table-column
        align="center"
        label="2023年12月31日诉讼状态">
        <el-table-column
          align="center"
          prop="last_year_no_tj_num"
          label="未提交"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="last_year_tj_num"
          label="提交"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="last_year_st_num"
          label="诉调"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="last_year_la_num"
          label="立案"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="last_year_hj_num"
          label="合计"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        prop="year_num"
        label="2024年新增"
        width="100">
      </el-table-column>
      <el-table-column
        align="center"
        prop="year_total_count"
        label="总计划"
        width="100">
      </el-table-column>

      <el-table-column
        align="center"
        label="1月计划">
        <el-table-column
          align="center"
          prop="month_1_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_1_amount"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="2月计划">
        <el-table-column
          align="center"
          prop="month_2_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_2_amount"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="3月计划">
        <el-table-column
          align="center"
          prop="month_3_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_3_amount"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="4月计划">
        <el-table-column
          align="center"
          prop="month_4_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_4_amount"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="5月计划">
        <el-table-column
          align="center"
          prop="month_5_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_5_amount"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="6月计划">
        <el-table-column
          align="center"
          prop="month_6_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_6_amount"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="7月计划">
        <el-table-column
          align="center"
          prop="month_7_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_7_amount"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="8月计划">
        <el-table-column
          align="center"
          prop="month_8_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_8_amount"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="9月计划">
        <el-table-column
          align="center"
          prop="month_9_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_9_amount"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="10月计划">
        <el-table-column
          align="center"
          prop="month_10_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_10_amount"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="11月计划">
        <el-table-column
          align="center"
          prop="month_11_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_11_amount"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="12月计划">
        <el-table-column
          align="center"
          prop="month_12_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_12_amount"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

    </el-table>
  </div>
  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                   :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                   @current-change="pageChange"></el-pagination>
  </div>
</div>
</template>

<script>
import ButlerHttp from "./common/ButlerHttp";

export default {
  name: "ExpeditingFeesPlanContenziosoShow",
  data(){
    return{
      batch_number:"",
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
    }
  },
  mounted() {
    const that=this;
    that.batch_number=that.$route.query.batch_number
    setTimeout(function () {
      that.pageChange(1);
    },500);
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      ButlerHttp.get("/ProjectCollectionProceedingPlanFlow/index",{
        batch_number:that.batch_number,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      },res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      if(this.batch_number!==''){
        this.getList();
      }
    },
    round(val,num=2) {
      return Math.round(val*100)/100
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./common";
.content2{
  background-color: #ffffff;
  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: flex;
    flex-direction: row;

    .header-tip-body{
      //width: 500px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      //justify-content: space-between;
      .header-tip-body-item{
        margin-left: 50px;
        display: flex;
        flex-direction: row;
      }
    }
  }
  .pagination-wrap{
    margin-top: 10px;
    text-align: center;
  }

  >>>.el-table--border, .el-table--group{
    border: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
    border-bottom: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/ExpeditingFeesPlanContenziosoShow.vue